import React, { useEffect, useRef, useState } from "react";
import logo from "../assetsWeb/images/logo-white.png";
import logo1 from "../assets/img/logo.png";
import logo2 from "../assets/img/logo-white.png";
import logo3 from "../assets/img/logo-small.png";
import music from "../assets/music/notification-sound-3.mp3";
import { Link, useNavigate } from "react-router-dom";
import { userLogout } from "../actions/authActions";
import { useDispatch, useSelector } from "react-redux";
import io from "socket.io-client";

import {
  SERVERADDRESS,
  SOCKET_SERVER_ADDRESS,
  // TOGGLE_SIDEBAR,
  // MESSAGE_RECEIVE_SUCCESS,
  NOTIFICATION_RECEIVE_SUCCESS,
  // SOCKETADDRESS,
  SOCKET_CONNECTED,
  SOCKET_DISCONNECT,
  CHAT_SELECT_SUCCESS,
  REMINDER_RECEIVE_SUCCESS,
  RESERVATION_UPDATE_SUCCESS,
  ROUTE_UPDATE_SUCCESS,
  ORDER_CREATE_SUCCESS,
} from "../constants";
import moment from "moment";

const Header = () => {
  const orders = useSelector((state) => state.orders);
  const auth = useSelector((state) => state.auth);
  const sockets = useSelector((state) => state.sockets);
  const chats = useSelector((state) => state.chats);
  let socketInstance;
  const notificationRef = useRef();
  // const { socketConnected } = sockets;
  const dispatch = useDispatch();
  let navigate = useNavigate();

  const navigateUser = () => {
    navigate("/login");
  };
  const logout = async (e) => {
    await dispatch(
      userLogout({ refreshToken: auth.tokens.refresh.token }, navigateUser)
    );
  };
  const [showNotifications, setShowNotifications] = useState(false);
  const dropdownRef = useRef(null);
  const openNotifications = () => {
    setShowNotifications((prev) => !prev);
  };
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [showLogout, setShowLogout] = useState(false);

  const openLogout = () => {
    setShowLogout((prev) => !prev);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowLogout(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    socketInstance = io(SOCKET_SERVER_ADDRESS, {
      transports: ["polling"],
      // transports: ["websocket"],
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 10000,
      reconnectionAttempts: Infinity,
    });
    socketInstance?.emit("newUser", {
      _id: auth?.user?.id,
      role: auth?.user?.role,
      ...(auth?.user?.storeId && { storeId: auth?.user?.storeId }),
    });
    socketInstance?.on("connected", () => {
      dispatch({
        type: SOCKET_CONNECTED,
        payload: { socketInstance, socketConnected: true },
      });
    });
    // socketInstance?.on("reconnect-user", (socketId) => {
    //   // console.log("Reconnect event received, socketId:", socketId);
    //   if (auth.user.id) {
    //     socketInstance?.emit("newUser", auth.user.id); // Re-emit the newUser event
    //   }
    // });
    return () => {
      // console.log("Disconnecting socket...");
      socketInstance?.disconnect();
      // console.log("Socket disconnected");
      socketInstance.off("connected");
      // socketInstance.off("reconnect-user");
      dispatch({
        type: SOCKET_DISCONNECT,
        payload: { socketInstance: null, socketConnected: false },
      });
    };
  }, []);

  useEffect(() => {
    if (socketInstance) {
      socketInstance?.on("order:insert", (orderRecieved) => {
        // console.log("order:insert==>", orderRecieved);
        dispatch({
          type: ORDER_CREATE_SUCCESS,
          payload: orderRecieved,
        });
        notificationRef.current.play();
      });

      //   socketInstance?.on("new-ride-req-received", (orderRecieved) => {
      //     // console.log("new-ride-req-received==>", orderRecieved);
      //     // dispatch({
      //     //   type: MESSAGE_RECEIVE_SUCCESS,
      //     //   payload: orderRecieved,
      //     // });
      //     notificationRef.current.play();
      //   });

      //   socketInstance?.on("notification recieved", (notificationReceived) => {
      //     // console.log("notification received==>", notificationReceived);
      //     dispatch({
      //       type: NOTIFICATION_RECEIVE_SUCCESS,
      //       payload: notificationReceived,
      //     });
      //     notificationRef.current.play();
      //   });
      //   socketInstance?.on(
      //     `receive-reminder-note${auth?.user?.companyId?.id}`,
      //     (reminderReceived) => {
      //       // console.log(
      //       //   reminderReceived,
      //       //   "reminderReceivedreminderReceivedreminderReceived"
      //       // );
      //       dispatch({
      //         type: REMINDER_RECEIVE_SUCCESS,
      //         payload: reminderReceived,
      //       });
      //     }
      //   );
      //   socketInstance?.on(
      //     "receive-reservation-detail",
      //     (newNotificationRecieved) => {
      //       // console.log("reservation received==>", newNotificationRecieved);
      //       const { reservation, trip } = newNotificationRecieved;
      //       dispatch({
      //         type: RESERVATION_UPDATE_SUCCESS,
      //         payload: reservation,
      //       });
      //     }
      //   );
      //   socketInstance?.on("receive-route-detail", (newNotificationRecieved) => {
      //     // console.log("route received==>", newNotificationRecieved);
      //     const { route, tripAM, tripPM, tripMID, date } =
      //       newNotificationRecieved;
      //     // console.log(
      //     //   "route received==>",
      //     //   routes?.routeDetails,
      //     //   routes?.routeDetails?.route,
      //     //   routes?.routeDetails?.route?.id.toString(),
      //     //   route.id.toString(),
      //     //   routes?.routeDetails?.route?.id.toString() == route.id.toString()
      //     // );
      //     if (routes?.routeDetails?.route?.id.toString() == route.id.toString()) {
      //       dispatch(
      //         setRouteData({
      //           route,
      //           tripAM,
      //           tripPM,
      //           tripMID,
      //           date,
      //         })
      //       );
      //     } else {
      //       dispatch({
      //         type: ROUTE_UPDATE_SUCCESS,
      //         payload: route,
      //       });
      //     }
      //   });
      //   if (auth?.user?.permissionId?.booking?.isAllow === true) {
      //     socketInstance?.on(
      //       "receive-notification-to-dispatcher",
      //       (newNotificationRecieved) => {
      //         // console.log("notification received==>", newNotificationRecieved);
      //         // auth.tokens.refresh.token &&
      //         if (isVisible) {
      //           rideNotification(newNotificationRecieved.text);
      //         }
      //       }
      //     );
      //   }
    }
    return () => {
      socketInstance.off("order:insert");
      // socketInstance.off("receive-notification-to-dispatcher");
      // socketInstance.off(`receive-reminder-note${auth?.user?.companyId?.id}`);
      // socketInstance.off("notification recieved");
      // socketInstance.off("new-ride-req-received");
      // socketInstance.off("receive-reservation-detail");
      // socketInstance.off("receive-route-detail");
    };
  }, [socketInstance]);

  return (
    <>
      <div className="header header-one">
        <div className="header-left header-left-one">
          <Link to="/dashboard" className="logo">
            <img src={logo} alt="Logo" />
          </Link>
          <Link to="/dashboard" className="white-logo">
            <img src={logo} alt="Logo" />
          </Link>
          <Link to="/dashboard" className="logo logo-small">
            <img src={logo} alt="Logo" width="30" height="30" />
          </Link>
        </div>
        <Link to="" id="toggle_btn">
          <i className="fas fa-bars"></i>
        </Link>
        <div className="top-nav-search d-flex align-items-center h-100">
          <h5 className="headertitle">Dashboard</h5>
        </div>
        <Link className="mobile_btn" id="mobile_btn">
          <i className="fas fa-bars"></i>
        </Link>
        <ul className="nav nav-tabs user-menu">
          <li
            className="nav-item dropdown"
            ref={dropdownRef}
            onClick={openNotifications}
          >
            <Link
              to="#"
              className="dropdown-toggle nav-link"
              data-bs-toggle="dropdown"
            >
              <i className="fa fa-bell"></i>{" "}
              <span className="badge rounded-pill">0</span>
            </Link>
            <div
              className={`dropdown-menu notifications ${
                showNotifications === true ? "show" : "hide"
              }`}
              style={{
                position: "absolute",
                inset: "0px auto auto 0px",
                margin: "0px",
                transform: "translate3d(-202px, 60px, 0px)",
                border: "1px solid lightgrey",
                borderRadius: "7px",
              }}
            >
              <div className="topnav-dropdown-header">
                <span className="notification-title">Notifications</span>
                <Link to="" className="clear-noti">
                  {" "}
                  Clear All
                </Link>
              </div>
              <div className="noti-content">
                <ul className="notification-list">
                  {/* You don't have any notifications yet */}
                  {/* {data.length === 0 && (
                    <p className="text-center my-5">
                      You don't have any notifications yet!{" "}
                    </p>
                  )} */}
                  {orders &&
                    orders?.orders &&
                    orders?.orders?.length > 0 &&
                    // orders?.orders?.map((current, i) => {
                    orders?.orders?.map((current, i) => {
                      if (current.status === "Pending") {
                        return (
                          <li className="notification-message">
                            <Link to="activities.html">
                              <div className="media d-flex">
                                <span className="avatar avatar-sm">
                                  <div className="avatar avatar-sm">
                                    <span className="avatar-title rounded-circle bg-primary-light">
                                      <i className="far fa-user"></i>
                                    </span>
                                  </div>
                                  {/* <img
                                          className="avatar-img rounded-circle"
                                          alt=""
                                          src="assets/img/profiles/avatar-03.jpg"
                                        /> */}
                                </span>
                                <div className="media-body">
                                  <p className="noti-details" key={i}>
                                    <span className="noti-title">
                                      {`${current?.userId?.firstName} ${current?.userId?.lastName} `}
                                    </span>
                                    placed the order{" "}
                                    <span className="noti-title">
                                      {current?.orderNo}
                                    </span>
                                  </p>
                                  <p className="noti-time">
                                    <span className="notification-time">
                                      {moment(current?.date).fromNow()}
                                    </span>
                                  </p>
                                </div>
                              </div>
                            </Link>
                          </li>
                        );
                      }
                    })}
                  {/* <li className="notification-message">
                    <Link to="activities.html">
                      <div className="media d-flex">
                        <span className="avatar avatar-sm">
                          <div className="avatar avatar-sm">
                            <span className="avatar-title rounded-circle bg-primary-light">
                              <i className="far fa-user"></i>
                            </span>
                          </div>
                        </span>
                        <div className="media-body">
                          <p className="noti-details">
                            <span className="noti-title">Brian Johnson </span>
                            paid the invoice{" "}
                            <span className="noti-title">#DF65485</span>
                          </p>
                          <p className="noti-time">
                            <span className="notification-time">
                              4 mins ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li className="notification-message">
                    <Link to="activities.html">
                      <div className="media d-flex">
                        <span className="avatar avatar-sm">
                          <div className="avatar avatar-sm">
                            <span className="avatar-title rounded-circle bg-primary-light">
                              <i className="far fa-user"></i>
                            </span>
                          </div>
                        </span>
                        <div className="media-body">
                          <p className="noti-details">
                            <span className="noti-title">Marie Canales </span>
                            has accepted your estimate{" "}
                            <span className="noti-title">#GTR458789</span>
                          </p>
                          <p className="noti-time">
                            <span className="notification-time">
                              6 mins ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li className="notification-message">
                    <Link to="activities.html">
                      <div className="media d-flex">
                        <div className="avatar avatar-sm">
                          <span className="avatar-title rounded-circle bg-primary-light">
                            <i className="far fa-user"></i>
                          </span>
                        </div>
                        <div className="media-body">
                          <p className="noti-details">
                            <span className="noti-title">
                              New user registered
                            </span>
                          </p>
                          <p className="noti-time">
                            <span className="notification-time">
                              8 mins ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li className="notification-message">
                    <Link to="activities.html">
                      <div className="media d-flex">
                        <span className="avatar avatar-sm">
                          <div className="avatar avatar-sm">
                            <span className="avatar-title rounded-circle bg-primary-light">
                              <i className="far fa-user"></i>
                            </span>
                          </div>
                        </span>
                        <div className="media-body">
                          <p className="noti-details">
                            <span className="noti-title">Barbara Moore </span>{" "}
                            declined the invoice{" "}
                            <span className="noti-title">#RDW026896</span>
                          </p>
                          <p className="noti-time">
                            <span className="notification-time">
                              12 mins ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li
                    className="notification-message"
                    style={{ cursor: "not-allowed" }}
                  >
                    <Link to="activities.html">
                      <div className="media d-flex">
                        <div className="avatar avatar-sm">
                          <span className="avatar-title rounded-circle bg-info-light">
                            <i className="far fa-comment"></i>
                          </span>
                        </div>
                        <div className="media-body">
                          <p className="noti-details">
                            <span className="noti-title">
                              You have received a new message
                            </span>
                          </p>
                          <p className="noti-time">
                            <span className="notification-time">
                              2 days ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </li> */}
                </ul>
              </div>
              <div className="topnav-dropdown-footer">
                <Link to="activities.html">View all Notifications</Link>
              </div>
            </div>
          </li>

          <li
            className="nav-item dropdown has-arrow main-drop"
            ref={dropdownRef}
          >
            <Link
              to="#"
              className="dropdown-toggle nav-link"
              data-bs-toggle="dropdown"
              onClick={openLogout}
            >
              <span className="user-img">
                <img src="assets/img/profiles/avatar-01.jpg" alt="" />
                <span className="status online"></span>
              </span>
              <span>Admin</span>
            </Link>
            <div
              className={`dropdown-menu ${showLogout ? "show" : ""}`}
              style={{
                position: "absolute",
                inset: "0px 0px auto auto",
                margin: "0px",
                transform: "translate3d(0px, 62px, 0px)",
              }}
            >
              <Link className="dropdown-item" to="#">
                <i className="fa fa-user me-1"></i>
                Profile
              </Link>
              <Link className="dropdown-item" to="#">
                <i className="fa fa-gear me-1"></i>
                Settings
              </Link>
              <Link className="dropdown-item" to="" onClick={logout}>
                <i className="fa fa-right-from-bracket me-1"></i>
                Logout
              </Link>
            </div>
          </li>
        </ul>
      </div>
      <audio src={music} ref={notificationRef}></audio>
    </>
  );
};
export default Header;
